import { DefaultValueExceptionType } from "../../../helpers/types/common";
import { KeyValueMap } from "../../../redux/slices/appState/models";
import { Locale } from "../common/models";

export interface LineOfBusiness {
  id: string;
  name: string;
}

export interface LineOfBusinessResponse {
  data: LineOfBusinessResponse[];
}

export interface SearchProgramTemplateParams {
  name: string;
  nameFilter: string;
  lineOfBusinessId: string;
  programFrameWorkId: string;
  status: string;
  countryIds: string[];
}

export interface SolutionCategoryParams {
  languageCode?: string;
  lineOfBusinessId?: string;
}

export interface SolutionCategoryLobParams {
  languageCode?: string;
  solutionCategoryId: string;
}

export interface ProgramClassParams {
  languageCode?: string;
  solutionOfferingId: string;
}

export interface CreateProgramTemplateParams {
  id?: string;
  name: string;
  lineOfBusinessId: string;
  programFrameWorkId: string;
  solutionCategoryId: string;
  solutionCategoryLOBId: string;
  solutionOfferingId: string;
  programClassId: string;
  durationInMoths: number;
  status: string;
  country: string[];
  entityType?: number;
  localizedProgramTemplateNames?: KeyValueMap;
  closingReason: string;
  nextAccess: boolean;
}

export interface CreateActivityParams {
  id?: string;
  programTemplateId: string;
  activityType: string;
  modality: string[];
  topic: string;
  activityStatus: string;
  units: string;
  candidateStatus: string[];
  deliverableIds: string[];
  triggerBilling: boolean;
  countsTowardsLastContactDate: boolean;
  triggerTouchPointSurvey: boolean;
  measurement: string;
  defaultValueExceptions: DefaultValueExceptionType[];
  localizedTopics: Locale[];
}

export interface ViewActivityResponse {
  id?: string;
  programTemplateId: string;
  activityName: string;
  activityType: string;
  modality: string[];
  topic: string;
  activityClass: string;
  activityStatus: string;
  units: string;
  candidateStatus: string[];
  triggerBilling: boolean;
  countsTowardsLastContactDate: boolean;
  triggerTouchPointSurvey: boolean;
  measurement: string;
  deliverables: {
    id: string;
    name: string;
  }[];
  defaultValueExceptions: {
    countryTitle: string;
    countryCode: string;
    units: string;
    measurement: string;
  }[];
}

export interface UpdateActivityParams extends CreateActivityParams {
  activityId: string;
  activityName?: string;
}

export interface CreateDeliverableParams {
  name: string;
  deliverableType: string;
  units: string;
  measurement: string;
  localizedDeliverableNames: string[];
}

export interface AddExistingDeliverableParams {
  deliverableIds: string[];
}
export interface ProgramTemplateListParams {
  clientId?: string;
  lobId?: string;
  countryId?: string;
  isRefetch?: boolean;
  solutionOfferingsId?: string;
  solutionOfferingsName?: string;
}

export const templateListType = {
  bulkTransfer: "bulkTransfer",
};

export interface CompatibleProgramTemplateListByCountryParams {
  templateId: string;
  countryId: string;
  isRefetch?: boolean;
}

export interface CompatibleProgramTemplateListParams {
  templateId: string;
  isRefetch?: boolean;
}

export interface CreateCompatibleParams {
  compatibleProgramTemplateId: string;
  duration: number;
  countryCode: string;
}

export interface GroupedLOBParams {
  clientId?: string;
  isRefetch?: boolean;
}
